/* import __COLOCATED_TEMPLATE__ from './team-multiselect.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { cached } from 'tracked-toolbox';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type TeamSummary from 'embercom/objects/inbox/team-summary';

interface Arguments {
  onTeamsChange: (selectedTeams: number[]) => void;
  excludedTeamIds?: Set<number>;
  teamType?: string;
}

interface Signature {
  Args: Arguments;
  Element: HTMLDivElement;
}

export default class TeamMultiselect extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked teamCache = new Map<number, TeamSummary>();
  @tracked selectedTeams: number[] = [];

  constructor(owner: unknown, args: Arguments) {
    super(owner, args);
  }

  willDestroy(): void {
    super.willDestroy();
    this.teamCache.clear();
  }

  get hasSelectedTeams(): boolean {
    return this.selectedTeams.length > 0;
  }

  @cached
  get selectedTeamObjects(): TeamSummary[] {
    let selectedTeamObjects = this.selectedTeams
      .map((team_id) => this.teamCache.get(team_id))
      .filter((team): team is TeamSummary => Boolean(team));
    return selectedTeamObjects;
  }

  @action onSelectTeam(teamSummary: TeamSummary): void {
    this.teamCache.set(teamSummary.id, teamSummary);
    this.selectedTeams = [...this.selectedTeams, teamSummary.id];

    this.args.onTeamsChange?.(this.selectedTeams);
  }

  @action removeTeam(teamId: number): void {
    this.selectedTeams = this.selectedTeams.filter((team_id) => team_id !== teamId);

    this.args.onTeamsChange?.(this.selectedTeams);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::Invites::Configuration::TeamMultiselect': typeof TeamMultiselect;
    'settings/teammates/invites/configuration/team-multiselect': typeof TeamMultiselect;
  }
}
